import React, { useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"

const RetractApplicationModal = ({
  show,
  onHide,
  onSubmit,
}: {
  show: boolean
  onHide: () => void
  onSubmit: (reason: string) => void
}): JSX.Element => {
  const [reason, setReason] = useState("")

  const trimmed = reason.trim()

  const submit = () => {
    if (!trimmed) return
    onSubmit(trimmed)
    onHide()
  }

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="retract-application-modal-title" centered>
      <Modal.Header closeButton>
        <Modal.Title id="retract-application-modal-title">Retract application?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your signed application will return to draft state. You will be able to edit and resubmit
          it, or cancel it. The cruise line will be notified with the reason you provide below.
        </p>
        <Form.Group>
          <Form.Label htmlFor="retract-application-reason">Reason for retraction</Form.Label>
          <Form.Control
            id="retract-application-reason"
            as="textarea"
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Explain briefly why you are retracting the application"
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Keep application submitted
        </Button>
        <Button variant="warning" onClick={submit} disabled={!trimmed}>
          Retract application
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default RetractApplicationModal
